import * as jose from 'jose';

import type { AuthenticationTokenPayload } from './types';

export interface HiveTokenMetadata {
    /**
     * Expiration date of the token.
     * Timestamp in milliseconds.
     */
    expiration: number;

    /**
     * Payload of the token.
     */
    payload: AuthenticationTokenPayload;
}

/**
 * Parse a Hive authentication token, before validation.
 * It can be used to extract metadata such as the expiration date.
 */
export function parseAuthToken(token: string): HiveTokenMetadata {
    const claims = jose.decodeJwt(token);

    return {
        expiration: claims.exp ? claims.exp * 1000 : Date.now() + 6 * 60 * 60 * 1000,
        payload: {
            // @ts-ignore
            userId: claims.userId,
            // @ts-ignore
            content: claims.content,
        },
    };
}
